module.exports = __webpack_public_path__ + "img/11.673171ff.jpg";